import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/semantic_word.json";
import fr from "@/locales/fr/puzzle-types/semantic_word.json";

export const SEMANTIC_WORD_NS = "puzzle-types/semantic_word";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerSemanticWordTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", SEMANTIC_WORD_NS))
    i18n.addResourceBundle("en", SEMANTIC_WORD_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", SEMANTIC_WORD_NS))
    i18n.addResourceBundle("fr", SEMANTIC_WORD_NS, fr, true, true);
}
